import axios from 'axios';
import { API_URL, DEFAULT_RESTAURANTE_ID } from '../config/env';

// Obtener ID del restaurante desde configuración de entorno o localStorage
const getRestauranteId = () => {
  // Prioridad 1: Configuración de entorno (.env.development o .env.production)
  if (DEFAULT_RESTAURANTE_ID) {
    return DEFAULT_RESTAURANTE_ID;
  }
  
  // Prioridad 2: Query param en URL
  const urlParams = new URLSearchParams(window.location.search);
  const restauranteParam = urlParams.get('restaurante');
  if (restauranteParam) {
    // Guardar en localStorage para mantener la selección
    localStorage.setItem('restaurante_id', restauranteParam);
    return restauranteParam;
  }
  
  // Prioridad 3: localStorage
  const storedId = localStorage.getItem('restaurante_id');
  if (storedId) {
    return storedId;
  }
  
  // Si no hay ninguno, retornar null (mostrará todos)
  return null;
};

// Crear instancia de axios sin autenticación
const publicApi = axios.create({
  baseURL: `${API_URL}/public`
});

// Interceptor para agregar el ID del restaurante a todas las peticiones
publicApi.interceptors.request.use((config) => {
  const restauranteId = getRestauranteId();
  if (restauranteId) {
    // Agregar como query param
    config.params = {
      ...config.params,
      restaurante: restauranteId
    };
  }
  return config;
});

// Obtener productos públicos
export const getProductosPublicos = async () => {
  const { data } = await publicApi.get('/productos');
  return Array.isArray(data) ? data : data.productos || [];
};

// Obtener un producto público
export const getProductoPublico = async (id) => {
  const { data } = await publicApi.get(`/productos/${id}`);
  return data;
};

// Obtener publicaciones públicas
export const getPublicacionesPublicas = async () => {
  const { data } = await publicApi.get('/publicaciones');
  return Array.isArray(data) ? data : data.publicaciones || [];
};

// Obtener una publicación pública
export const getPublicacionPublica = async (id) => {
  const { data } = await publicApi.get(`/publicaciones/${id}`);
  return data;
};

// Obtener restaurantes públicos
export const getRestaurantesPublicos = async () => {
  const { data } = await publicApi.get('/restaurantes');
  return Array.isArray(data) ? data : data.restaurantes || [];
};

// Obtener categorías públicas
export const getCategoriasPublicas = async () => {
  const { data } = await publicApi.get('/categorias');
  return Array.isArray(data) ? data : data.categorias || [];
};

// Obtener información del restaurante actual
export const getRestauranteActual = async () => {
  const { data } = await publicApi.get('/restaurante');
  return data;
};

// Obtener establecimientos del restaurante actual
export const getEstablecimientosPublicos = async () => {
  const { data } = await publicApi.get('/establecimientos');
  return Array.isArray(data) ? data : data.establecimientos || [];
};

// Obtener redes sociales del restaurante actual
export const getRedesSocialesPublicas = async () => {
  const { data } = await publicApi.get('/redes-sociales');
  return Array.isArray(data) ? data : data.redes || [];
};

// Enviar mensaje de contacto
export const enviarMensajeContacto = async (formData) => {
  const { data } = await publicApi.post('/contacto', formData);
  return data;
};

// Función para cambiar de restaurante manualmente
export const setRestauranteActual = (id) => {
  if (id) {
    localStorage.setItem('restaurante_id', id);
  } else {
    localStorage.removeItem('restaurante_id');
  }
  // Recargar la página para aplicar cambios
  window.location.reload();
};
